export class StopPlaceInsertFailed extends Error {}
